/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';

const replaceFontWeight = (node) => {
    if (node?.type === 'tag') {
        const styleAttribute = node.attribs?.style || '';
        const styleParts = styleAttribute.split(';');
        if (styleParts?.includes('font-weight:bold')) {
            // Remove the font-weight property from the style attribute
            const filteredStyle = styleParts?.filter((part) => !part.includes('font-weight:bold'));
            const nodesData = node;
            nodesData.attribs.style = filteredStyle.join(';');
            // Wrap the content in <strong> tags
            if (nodesData.children?.length > 0 && nodesData.children[0]?.data) {
                nodesData.children[0].data = <strong>{nodesData.children[0].data}</strong>;
            }
        }
    }
};

export default replaceFontWeight;
